import React from "react";
import { FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { SiFreelancer } from "react-icons/si";
import { contactImg } from "../../assets/index";
import "./Contact.css";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full glass-panel bg-slate-900/50 p-4 lgl:p-8 rounded-2xl flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-2xl font-bold text-white">
          Tarigopula Chandra Mouli
        </h3>
        <p className="text-lg font-normal text-gray-400">
          Full Stack Developer
        </p>
        <p className="text-sm text-slate-500 font-mono">
          Anantapur, Andhra Pradesh
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Full Stack Developer with 2+ years building enterprise-grade web
          applications across fintech, sports betting, and legal-tech. Open to
          Full Stack, Backend, NestJS/Node.js, and Software Engineer roles.
        </p>
        <p className="text-base text-gray-400 flex flex-wrap items-center gap-2">
          Phone:{" "}
          <a
            href="tel:+919347265574"
            className="btn-primary-agi font-semibold py-2 px-4 rounded-full transition-colors duration-200 animate-glow"
          >
            +91 9347265574
          </a>
        </p>
        <p className="text-base text-slate-400 flex flex-wrap items-center gap-2">
          Email:{" "}
          <a
            href="mailto:tarigopula.chandra.mouli@gmail.com"
            className="btn-primary-agi font-semibold py-2 px-4 rounded-full transition-colors duration-200 animate-glow"
          >
            tarigopula.chandra.mouli@gmail.com
          </a>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a
            href="https://github.com/chandramouli35"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/mouli-chandra/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://x.com/Chandra37006776"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.freelancer.in/u/Chandramouli1m"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <SiFreelancer />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
